import { defineStore } from 'pinia'
import { list, getItem, update } from '@/utils/index'
import { add } from 'lodash'

const URL = '/v1/reseller'
export const useReseller = defineStore('reseller', {
    state: () => ({
        data: {},
    }),

    getters: {
        my: (state) => state.data,
    },

    actions: {
        addReseller(payload ) {
            this.$state.data = payload
        },
        /**
         * search all reseller
         */
        async fetchItems() {
            return list ( this.$state, URL)
        },

        async fetchItem(id) {
            return getItem( this.$state, URL + '/' + id)
        },

        async editItem({ payload, id }) {
            return update( this.$state, URL + '/' + id, payload)
        },
    },
})